webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(14);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(8);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '#app',
	    render: function render(createElement) {
	        return createElement(_App2.default);
	    }
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var items = [{
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list01.jpg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list01.jpg-square',
	    state: "hide"
	}, {
	    desc: "大量描述自动折行，限制两行，自动省略号。大量描述自动折行，限制两行，自动省略号。大量描述自动折行，限制两行，自动省略号。",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list02.jpg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list02.jpg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list03.jpg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list03.jpg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list04.JPG-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list04.JPG-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list05.JPG-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list05.JPG-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list06.jpeg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list06.jpeg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list07.jpeg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list07.jpeg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list08.jpg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list08.jpg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list10.jpg-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list10.jpg-square',
	    state: "hide"
	}, {
	    desc: "This is a lazy item.",
	    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list09.png-small',
	    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list09.png-square',
	    state: "hide"
	}];
	
	exports.default = items;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _LazyItem = __webpack_require__(9);
	
	var _LazyItem2 = _interopRequireDefault(_LazyItem);
	
	var _LoadMore = __webpack_require__(10);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	var _items = __webpack_require__(1);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	      data: function data() {
	            return {
	                  items: _items2.default,
	                  itemsPos: [],
	                  timer: null,
	                  loader: [],
	                  isScrolling: false,
	                  isLoading: false
	            };
	      },
	      components: {
	            LazyItem: _LazyItem2.default,
	            LoadMore: _LoadMore2.default
	      },
	      mounted: function mounted() {
	            this.initPos(0);
	            this.initStates();
	            this.bindEvent();
	      },
	      methods: {
	            toggleLoad: function toggleLoad(e) {
	                  if (e && !this.isLoading) {
	                        this.isLoading = !this.isLoading;
	                        this.loadMore();
	                  } else if (!e) {
	                        this.isLoading = !this.isLoading;
	                  }
	            },
	            loadMore: function loadMore() {
	                  var _this = this;
	
	                  setTimeout(function () {
	                        var tmp = [];
	                        for (var i = 0; i < 9; i++) {
	                              var t = {};
	                              var index = Math.floor(10 * Math.random());
	                              for (var key in _this.items[index]) {
	                                    t[key] = _this.items[index][key];
	                              }
	                              t.state = "hide";
	                              tmp.push(t);
	                        }
	                        _this.items = _this.items.concat(tmp);
	                        _this.$nextTick(function () {
	                              this.initPos(this.itemsPos.length);
	                        });
	                        _this.toggleLoad();
	                  }, 1600);
	            },
	            initPos: function initPos(start) {
	                  var eles = document.querySelectorAll(".lazy-wrap");
	                  for (var i = start; i < eles.length; i++) {
	                        this.itemsPos.push(eles[i].offsetTop);
	                  }
	            },
	            initStates: function initStates() {
	                  var _this2 = this;
	
	                  this.itemsPos.some(function (pos, index) {
	                        if (pos >= window.innerHeight) {
	                              return true;
	                        } else {
	                              _this2.items[index].state = "show";
	                        }
	                  });
	            },
	            clearLoader: function clearLoader() {
	                  if (this.loader.length) {
	                        this.loader.forEach(function (v) {
	                              clearTimeout(v);
	                        });
	                        this.loader.length = 0;
	                  }
	            },
	            bindEvent: function bindEvent() {
	                  var _this3 = this;
	
	                  window.addEventListener("scroll", function (e) {
	                        if (_this3.isScrolling) {
	                              _this3.clearLoader();
	                              return;
	                        } else {
	                              _this3.isScrolling = true;
	                              _this3.timer = setTimeout(function () {
	                                    _this3.clearLoader();
	                                    var st = document.body.scrollTop;
	                                    _this3.itemsPos.some(function (pos, index) {
	                                          if (pos >= st + window.innerHeight - 200) {
	                                                return true;
	                                          } else if (pos >= st - 200) {
	                                                _this3.loader.push(setTimeout(function () {
	                                                      _this3.items[index].state = "show";
	                                                }, 250));
	                                          }
	                                    });
	                                    _this3.isScrolling = false;
	                              }, 250);
	                        }
	                  });
	            }
	      }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = {
	      props: ['itemData'],
	      data: function data() {
	            return {
	                  imgSrc: ''
	            };
	      },
	      computed: {
	            itemState: function itemState() {
	                  this.showPic(this.itemData.state);
	                  return this.itemData.state;
	            }
	      },
	      methods: {
	            showPic: function showPic(state) {
	                  var _this = this;
	
	                  if (state === "show") {
	                        this.imgSrc = this.itemData.smallSrc;
	                        var img = new Image();
	                        img.onload = function () {
	                              _this.imgSrc = _this.itemData.bigSrc;
	                        };
	                        img.src = this.itemData.bigSrc;
	                  }
	            }
	      }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = {
	      props: ['isLoading']
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(2)
	
	/* template */
	var __vue_template__ = __webpack_require__(11)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(6)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(12)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2"
	
	module.exports = __vue_exports__


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	
	/* styles */
	__webpack_require__(7)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(13)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3"
	
	module.exports = __vue_exports__


/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_m(0), " ", _m(1), " ", _l((items), function(item) {
	    return _h('div', [_h('lazy-item', {
	      attrs: {
	        "item-data": item
	      }
	    }), " ", _m(2, true)])
	  }), " ", _h('load-more', {
	    attrs: {
	      "is-loading": isLoading
	    },
	    nativeOn: {
	      "click": function($event) {
	        toggleLoad($event)
	      }
	    }
	  })])
	}},staticRenderFns: [function (){with(this) {
	  return _h('div', {
	    staticClass: "head"
	  }, [_h('h2', ["Vue lazy scroll loading"])])
	}},function (){with(this) {
	  return _h('div', {
	    staticClass: "descp"
	  }, [_h('p', ["基于", _h('b', ["Vue2.0"]), "实现，图片随滚动", _h('b', ["延迟"]), "加载，先请求", _h('b', ["缩略图"]), "，缩略图加载后带模糊效果。滚动到底部后可", _h('b', ["异步加载"]), "更多内容，实现无限加载。"])])
	}},function (){with(this) {
	  return _h('i', {
	    staticClass: "divide"
	  })
	}}]}

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "lazy-wrap"
	  }, [_h('transition', {
	    attrs: {
	      "name": "show"
	    }
	  }, [(itemState !== 'hide') ? _h('div', {
	    staticClass: "lazy-content"
	  }, [_h('div', {
	    staticClass: "img-wrap"
	  }, [_h('img', {
	    class: {
	      blur: itemState === 'small'
	    },
	    attrs: {
	      "src": imgSrc
	    }
	  })]), " ", (itemData.desc) ? _h('div', {
	    staticClass: "desc"
	  }, [_h('p', [_s(itemData.desc)])]) : _e()]) : _e()]), " ", (itemState === 'hide') ? _h('div', {
	    staticClass: "lazy-replace"
	  }, [_m(0)]) : _e()])
	}},staticRenderFns: [function (){with(this) {
	  return _h('span', ["lazy-item"])
	}}]}

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports={render:function (){with(this) {
	  return _h('div', {
	    staticClass: "load-more"
	  }, [_h('span', {
	    directives: [{
	      name: "show",
	      value: (!isLoading),
	      expression: "!isLoading"
	    }]
	  }, ["加载更多···"]), " ", _h('span', {
	    directives: [{
	      name: "show",
	      value: (isLoading),
	      expression: "isLoading"
	    }],
	    staticClass: "loading"
	  })])
	}},staticRenderFns: []}

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.953c5f28bb104e0addbc.js
 **/